import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeliveryInformation } from 'src/app/model/deliveryChoiceModels/deliveryInformation.model';
import { PickupInformation } from 'src/app/model/deliveryChoiceModels/pickupInformation.model';
import { RefDeliveryinformation } from 'src/app/model/refDeliveryinformation.model';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { DeliveryChoiceService } from 'src/app/services/delivery-choice.service';
import { DeliveryDialogComponent } from '../delivery-dialog/delivery-dialog.component';

@Component({
  selector: 'app-pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.scss']
})
export class PickupComponent implements OnInit {

  pickupLocationId: string;
  pickupTypePoint: string;
  userHasChoose: boolean = false;
  pickupInfo: DeliveryInformation;
  selectedDeliveryPoint: PickupInformation;
  labelChoice: string;
  isEmailValid: boolean = false;
  confirmAction: boolean = false;
  choiceConfirmed: boolean = false;
  isPickupSelected: boolean = false;
  hoursSelected: boolean = false;
  chosenDeliveryPoint: PickupInformation;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PickupComponent>,
    private deliveryChoiceService: DeliveryChoiceService,
    private atInternetService: AtInternetService) { }

  ngOnInit() {
    //on ne peut pas appeler le AtInternetService.generatePage()
    // à cause de la clef :"choix_livraison"
    try {
      this.data.tag.setProps({
        page: 'reprogrammation_hors_domicile',
        choix_livraison: 'recuperer_en_point_retrait'
      }, true);
      this.data.tag.page.set({
        name: 'reprogrammation_hors_domicile'
      });
      this.data.tag.dispatch();
    } catch (e) {
    }
  }

  //fermer la popin
  onNoClick() {
    this.dialogRef.close();
  }

  //fonction pour controller qu'un point de retrait est bien choisi
  validatePickup(deliveryPoint) {

    this.chosenDeliveryPoint = deliveryPoint;
    this.isPickupSelected = true;
  }
  selectPickup(index) {

    if (this.chosenDeliveryPoint.order === index) {
      this.hoursSelected = true;
    }
  }

  saveChoices(): void {
    this.atInternetService.generatePage(
      this.data.tag,
      'reprogrammation_hors_domicile_recapitulation',
      'reprogrammation_hors_domicile_recapitulation'
    );
    this.confirmAction = true;
  }

  checkEmail(isValid: boolean) {
    this.isEmailValid = isValid;
  }

  modifyChoiceDate() {
    this.dialog.open(DeliveryDialogComponent, { disableClose: true, panelClass: 'delivery-choice-dialog', data: { "deliveryChoiceResponse": this.data.deliveryChoiceResponse, "tag": this.data.tag, "shortCode1": this.data.shortCode1, "shortCode2": this.data.shortCode2, "isModify":true } });
    this.onNoClick();
  }

  //pour retourner à l'état précédant et refill les champs du formulaire
  modifyChoice = (): void => {
    this.atInternetService.generateClickAction(
      this.data.tag,
      'modifier',
      'popin_modification_confirmation_adresse_point_retrait'
    );
    this.confirmAction = false;
  }

  validateChoice = (email: string): void => {
    //TODO mettre ça lorsque le message a bien été envoyé au SI COLIS
    this.deliveryChoiceService.validateChoice(
      this.data.shortCode1,
      this.data.shortCode2,
      this.data.lang,
      this.data.deliveryChoiceResponse.consigneeInformation.zipCode,
      this.switchPickupPoint(this.chosenDeliveryPoint.typePoint),
      null,
      this.chosenDeliveryPoint.locationId,
      email).subscribe(
        response => {
          response.forEach(oneMessage => {
            // TODO quand on saura comment traiter les erreurs du WS
            if (oneMessage.id === "0") {
              this.atInternetService.generateClickAction(
                this.data.tag,
                'confirmer',
                'popin_modification_confirmation_adresse_point_retrait'
              );
              this.choiceConfirmed = true
            }
          }
          )
        }
      );
  }

  switchPickupPoint(typePoint) {
    switch (typePoint) {
      case "BPR":
        this.pickupTypePoint = "RSDBPI";
        return this.pickupTypePoint;
      case "A2P":
      case "PKM":
        this.pickupTypePoint = "RSDREL";
        return this.pickupTypePoint;
      case "CIT":
        this.pickupTypePoint = "RSDCNS";
        return this.pickupTypePoint;
      default:
        break;
    }
  }

  transformIntoRefComponent(deliveryPoint) {
    var refDeliveryinformation = new RefDeliveryinformation();
    refDeliveryinformation.startingPeriod = deliveryPoint.openHours.startRange;
    refDeliveryinformation.endingPeriod = deliveryPoint.openHours.stopRange;
    refDeliveryinformation.monday.push(deliveryPoint.openHours.monday);
    refDeliveryinformation.tuesday.push(deliveryPoint.openHours.tuesday);
    refDeliveryinformation.wednesday.push(deliveryPoint.openHours.wednesday);
    refDeliveryinformation.thursday.push(deliveryPoint.openHours.thursday);
    refDeliveryinformation.friday.push(deliveryPoint.openHours.friday);
    refDeliveryinformation.saturday.push(deliveryPoint.openHours.saturday);
    refDeliveryinformation.sunday.push(deliveryPoint.openHours.sunday);
    return refDeliveryinformation;
  }

  select(pickup) {
    this.chosenDeliveryPoint = pickup;
    this.validatePickup(pickup);
  }
}
